import React, { Component } from 'react';
import anime from 'animejs';


export const withNavItem = ComposedComponent => class extends Component {
  constructor() {
    super();
    this.markerPaths = [];
    this.images = [];
    this.imagesLoadedCounter = 0;
    this.isActiveLink = [false];
    this.navLink = [];

    // get error "Cannot assign to read only property" because can't mutate props
    // so use an array here. This is probably a crappy way to do this
  }

  state = {
    imagesLoadedClass: '',
    wobbling: '',
    groupA: '',
    groupB: '',
    groupC: '',
    groupD: '',
  }

  componentDidMount() {
    for (let i = 0; i < this.images.length; ++i) {
      // load event handlers on the <image> element are buggy in browsers.
      // there's no way to check if the <image> has loaded or not, like img.complete on regular images
      // Tried swapping in a new source for the <image> element. Worked in Chrome and FF, but not for desktop and mobile Safari
      // Tried adding in a new <image> element with JavaScript but the load event listener doesn't work in any browser on <image> elements added to the DOM with JS
      // Ended up creating a dummy <img> with the same src as the <image> and adding the load event listener to it. The dummy <img> is never added to the DOM
      const originalImage = this.images[i];
      const dummyImg = new Image();
      dummyImg.addEventListener('load', () => {
        this.handleImageLoad( // function takes callback ... could use promise here?
          () => { // when all images have loaded, do the following
            setTimeout(
              () => {
                this.animatePaths();
                this.setState({ imagesLoadedClass: 'imagesloaded' });
              }
              , 300); // end setTimeout
          },
        );
      }, false);
      dummyImg.src = originalImage.getAttribute('xlink:href');
    }
  }


  /////////////////////////////

  // https://tympanus.net/Development/MorphingBackgroundShapes/index.html

  /* eslint-disable */
  getMousePos(ev) {
    let posx = 0;
    let posy = 0;
    if (!ev) {
      ev = window.event;
    }
    if (ev.pageX || ev.pageY) {
      posx = ev.pageX;
      posy = ev.pageY;
    } else if (ev.clientX || ev.clientY) {
      posx = ev.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
      posy = ev.clientY + document.body.scrollTop + document.documentElement.scrollTop;
    }
    return { x: posx, y: posy };
  }
  /* eslint-enable no-unused-vars */

  mouseenterFn = () => {
    if (!this.isActiveLink[0] || Modernizr.touchevents) {
      return;
    }
    this.hover = true;
    this.setState({ wobbling: 'wobbling' });
    // console.log('mouse enter');
  }

  mousemoveFn = (ev) => {
    ev.persist(); // https://reactjs.org/docs/events.html#event-pooling
    if (!this.isActiveLink[0] || Modernizr.touchevents) {
      return;
    }
    // console.log('mouse move');
    requestAnimationFrame(() => this.layout(ev));
  }

  mouseleaveFn = () => {
    if (!this.isActiveLink[0] || Modernizr.touchevents) {
      return;
    }

    this.setState({
      wobbling: '',
      groupA: 'translate(0px)',
      groupB: 'translate(0px)',
      groupC: 'translate(0px)',
      groupD: 'translate(0px)',
    });
    this.hover = false;
    // console.log('mouse leave');
  }

  layout(ev) {
    if (!this.hover) { return; } // firefox sometimes calls layout after mouseleave, making the transforms stick rather than reset back to zero ... this ensures if the mouse is not over the element it won't call the layout function
    // Mouse position relative to the document.
    const mousepos = this.getMousePos(ev);
    // Document scrolls.
    const docScrolls = { left: document.body.scrollLeft + document.documentElement.scrollLeft, top: document.body.scrollTop + document.documentElement.scrollTop };
    const bounds = this.navLink[0].getBoundingClientRect();
    // Mouse position relative to the main element (this.DOM.el).
    const relmousepos = { x: mousepos.x - bounds.left - docScrolls.left, y: mousepos.y - bounds.top - docScrolls.top };

    // Movement settings for the animatable elements.
    const t = {
      groupA: { x: -40, y: -10 },
      groupB: { x: 10, y: 40 },
      groupC: { x: -20, y: 30 },
      groupD: { x: 30, y: -20 },
    };

    const getTransformXCoord = function getTransformXCoord(x) {
      return ((((-1 * x) - x) / bounds.width) * relmousepos.x) + x;
    };
    const getTransformYCoord = function getTransformYCoord(y) {
      return ((((-1 * y) - y) / bounds.height) * relmousepos.y) + y;
    };

    const groupA = {
      x: getTransformXCoord(t.groupA.x),
      y: getTransformYCoord(t.groupA.y),
    }
    const groupB = {
      x: getTransformXCoord(t.groupB.x),
      y: getTransformYCoord(t.groupB.y),
    }
    const groupC = {
      x: getTransformXCoord(t.groupC.x),
      y: getTransformYCoord(t.groupC.y),
    }
    const groupD = {
      x: getTransformXCoord(t.groupD.x),
      y: getTransformYCoord(t.groupD.y),
    }

    this.setState({
      groupA: `translateX(${groupA.x}px) translateY(${groupA.y}px)`,
      groupB: `translateX(${groupB.x}px) translateY(${groupB.y}px)`,
      groupC: `translateX(${groupC.x}px) translateY(${groupC.y}px)`,
      groupD: `translateX(${groupD.x}px) translateY(${groupD.y}px)`,
    });
  };



  /////////////////////////////


  svgImages(el, rendered) {
    if (el === null || rendered) { // don't keep adding in refs after rendered first time
      return;
    }
    this.images.push(el);
  }


    handleClick(e) {
      // disable clicking link if already on that link's destination
      if (this.isActiveLink[0]) {
        e.preventDefault();
      }
    }

    handleImageLoad(callback) {
      this.imagesLoadedCounter++;
      if (this.imagesLoadedCounter >= this.images.length) {
        if (callback && typeof (callback) === 'function') { // callback https://stackoverflow.com/questions/2190850/create-a-custom-callback-in-javascript
          callback();
          // remove event listeners
          for (let i = 0; i < this.images.length; ++i) {
            this.images[i].removeEventListener('load', () => this.handleImageLoad); // not sure how to check to make sure eventListener is removed ...
          }
        }
      }
    }

    animatePaths() {
      if (!this.isActiveLink[0]) { // only animate the activeLink when the page loads
        return;
      }
      const { markerPaths } = this;
      for (let i = 0; i < markerPaths.length; i++) {
        const path = markerPaths[i];
        const length = path.getTotalLength();
        path.setAttribute('strokeDasharray', length);
        //path.setAttribute('strokeDashoffset', length);
        path.style.strokeDashoffset = length;
      }
      // animate in navLinkActive svg strokes
      /* eslint-disable no-unused-vars */
      const markerDrawing = anime({
        targets: markerPaths,
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'easeInOutSine',
        duration: 400,
        delay(el, i) { return i * 150; },
        direction: 'alternate',
        loop: false,
      });
    }


    activePaths(el, rendered) {
      if (el === null || rendered) { // don't keep adding in refs after rendered first time, and only animate the activeLink when the page loads
        return;
      }

      this.markerPaths.push(el);
    }

    navLinkFunc(el, rendered) {
      if (el === null) {
        return;
      }
      this.navLink[0] = el;
      // console.log(this.navLink[0]);
    }

    isActiveLinkFunc(val) {
      this.isActiveLink[0] = val;
    }


  render() {
    // console.log('render navItem');
    // if (this.navLink[0] !== undefined) { // if navLink exists and is the activeLink
    //   // console.log('add event listeners');
    //   this.navLink[0].addEventListener('mousemove', this.mousemoveFn);
    //   this.navLink[0].addEventListener('mouseleave', this.mouseleaveFn);
    //   this.navLink[0].addEventListener('mouseenter', this.mouseenterFn);
    // }

    return (
      <ComposedComponent
        {...this.props}
        imagesLoadedClass={this.state.imagesLoadedClass}
        handleImageLoad={this.handleImageLoad}
        images={this.images}
        svgImages={this.svgImages}
        activePaths={this.activePaths}
        markerPaths={this.markerPaths}
        isActiveLink={this.isActiveLink}
        isActiveLinkFunc={this.isActiveLinkFunc}
        navLinkFunc={this.navLinkFunc}
        navLink={this.navLink}
        getMousePos={this.getMousePos}
        mouseenterFn={this.mouseenterFn}
        mousemoveFn={this.mousemoveFn}
        mouseleaveFn={this.mouseleaveFn}
        layout={this.layout}
        wobbling={this.state.wobbling}
        groupA={this.state.groupA}
        groupB={this.state.groupB}
        groupC={this.state.groupC}
        groupD={this.state.groupD}
        handleClick={this.handleClick}
      />
    );
  }
};


export default withNavItem;



// WEBPACK FOOTER //
// ./src/components/withNavItem.js